import React from 'react'
import Dashboard from '../dashboard'
import ServicesView from './page'

const Services = () => {
  return <Dashboard component={<ServicesView />} />
}

export default Services
